import {useEffect, useCallback} from 'react';
import {useLocation} from 'react-router-dom';
import {sendPostMessage} from './useSearchInpFocus';
import {debounce} from 'lodash';

const useInteraction = (iframeVisible) => {
  const location = useLocation();

  // 클릭 이벤트 핸들러 (모든 요소 감지)
  const handleClick = useCallback(() => {
    if (location.pathname !== '/') {
      return;
    }
    sendPostMessage('interaction');
  }, [location.pathname]);

  // 디바운싱된 스크롤 이벤트 핸들러 (200ms)
  const debouncedScroll = useCallback(
    debounce(() => {
      if (location.pathname !== '/') {
        return;
      }
      sendPostMessage('interaction');
    }, 200),
    [location.pathname],
  );

  useEffect(() => {
    if (location.pathname !== '/') {
      return;
    }

    // body에 클릭 이벤트 리스너 추가
    document.body.addEventListener('click', handleClick);

    // window에 스크롤 이벤트 리스너 추가 (디바운싱 적용)
    window.addEventListener('scroll', debouncedScroll);

    // Cleanup (이벤트 리스너 제거)
    return () => {
      document.body.removeEventListener('click', handleClick);
      window.removeEventListener('scroll', debouncedScroll);
      debouncedScroll.cancel(); // 디바운스 취소 (메모리 누수 방지)
    };
  }, [location.pathname, handleClick, debouncedScroll]);

  return null;
};

export default useInteraction;
